<template>
  <v-data-table
    :loading="loading"
    :items="projects"
    :headers="headers"
    :sort-by="['modified']"
    :sort-desc="[true]"
    :items-per-page="1000"
    mobile-breakpoint="0"
  >
    <template #[`item.freedom`]="{ item }">
      <v-icon :color="item.freedom ? 'success' : 'error'">
        {{ item.freedom ? 'public' : 'local_fire_department' }}
      </v-icon>
    </template>
    <template #[`item.id`]="{ item }">
      <a
        :href="item.editorUrl"
        target="_blank"
        class="text-decoration-underline info--text"
      >
        {{ item.id }}
      </a>
    </template>
    <template #[`item.created`]="{ item }">
      {{ item.created | normalDateWithTime }}
    </template>
    <template #[`item.modified`]="{ item }">
      {{ item.modified | normalDateWithTime }}
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'UserProjects',
  data: () => {
    return {
      headers: [
        { text: '', value: 'freedom' },
        { text: 'Id', value: 'id' },
        { text: 'Product', value: 'product' },
        { text: 'Name', value: 'name' },
        { text: 'Created', value: 'created' },
        { text: 'Modified', value: 'modified' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      user: 'users/user',
      projects: 'users/projects'
    })
  },
  mounted() {},
  methods: {}
};
</script>
